import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-switch d-flex align-items-start" }
const _hoisted_2 = ["id", "checked", "data-testid"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "label left-label" }
const _hoisted_5 = { class: "label right-label" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    modelValue: { type: Boolean },
    leftLabel: {},
    rightLabel: {},
    id: {},
    testId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const randomId = `toggle-${Math.random().toString(36).substring(2, 9)}`

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement | null
  if (target) {
    emit('update:modelValue', target.checked)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      id: __props.id ?? randomId,
      type: "checkbox",
      checked: __props.modelValue,
      onChange: onChange,
      "data-testid": __props.testId ?? 'toggle-switch'
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: __props.id ?? randomId
    }, null, 8, _hoisted_3),
    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.leftLabel), 1),
    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.rightLabel), 1)
  ]))
}
}

})